import { render, staticRenderFns } from "./PageFacebook.vue?vue&type=template&id=3c3feea1&"
import script from "./PageFacebook.vue?vue&type=script&lang=js&"
export * from "./PageFacebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports